import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { BUSINESS, waLink } from "@/data/site";

const links = [
  { label: "Products", id: "products" },
  { label: "Pricing", id: "pricing" },
  { label: "About", id: "about" },
  { label: "Contact", id: "contact" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "glass" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex items-center justify-between h-[72px]">
        <button
          onClick={() => scrollTo("top")}
          className="text-left"
          data-testid="nav-logo"
        >
          <span className="font-display text-xl font-semibold tracking-tight">
            V.S.V.<span className="text-white/50"> Agencies</span>
          </span>
          <span className="block overline text-[0.6rem] mt-0.5">
            Coimbatore · Tamil Nadu
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="text-sm text-white/70 hover:text-white transition-colors duration-300"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-medium text-black transition-transform duration-300 hover:-translate-y-0.5"
            data-testid="nav-enquire-btn"
          >
            Enquire Now
          </a>
        </nav>

        <button
          className="md:hidden text-white/80"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          <div className="space-y-1.5">
            <span className="block h-px w-6 bg-white" />
            <span className="block h-px w-6 bg-white" />
          </div>
        </button>
      </div>

      {open && (
        <div className="md:hidden glass border-t border-white/10 px-6 py-5 space-y-4">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => {
                scrollTo(l.id);
                setOpen(false);
              }}
              className="block text-white/80 text-base"
              data-testid={`nav-mobile-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex rounded-full bg-white px-5 py-2.5 text-sm font-medium text-black"
            data-testid="nav-mobile-enquire-btn"
          >
            Enquire on WhatsApp
          </a>
        </div>
      )}
    </motion.header>
  );
}
